var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNano4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 332.8 301.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17 {\n        stroke-miterlimit: 10;\n        stroke-width: .8px;\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-15, .cls-16, .cls-17 {\n        stroke: #000;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-11 {\n        fill: #e7edfc;\n      }\n\n      .cls-12, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-13 {\n        fill: #c1c6d5;\n      }\n\n      .cls-14 {\n        stroke: #fff;\n      }\n\n      .cls-14, .cls-16 {\n        fill: #2e2e2e;\n      }\n\n      .cls-15 {\n        fill: #c9cfdb;\n      }\n\n      .cls-17 {\n        fill: #f3b547;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 103.6,
    y1: 8.7,
    x2: 109.9,
    y2: 8.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5322e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd3027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 96.2,
    y1: 82.7,
    x2: 140.7,
    y2: 82.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 214.6,
    y1: 121.7,
    x2: 281.7,
    y2: 121.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 196.1,
    y1: 136.6,
    x2: 234.4,
    y2: 136.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 249.6,
    y1: 135.5,
    x2: 297.4,
    y2: 135.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 270.5,
    y1: 140.5,
    x2: 309.9,
    y2: 140.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 306.7,
    y1: 42.6,
    x2: 324.1,
    y2: 42.6,
    gradientTransform: "translate(297.6 -275.2) rotate(79.1)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m91.6.4h221.1c3.1,0,5.6,2.5,5.6,5.6v158.1c0,3.1-2.5,5.6-5.6,5.6H91.6c-3.1,0-5.6-2.5-5.6-5.6V6c0-3.1,2.5-5.6,5.6-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m318.3,91.1v73c0,3.1-2.5,5.6-5.6,5.6h-62.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 96.2,
    cy: 8.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 106.7,
    cy: 8.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 117.3,
    cy: 8.7,
    r: 3.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 283.2,
    y1: 11.1,
    x2: 287.9,
    y2: 11.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 306.1,
    y1: 6.2,
    x2: 311,
    y2: 11.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 311,
    y1: 6.2,
    x2: 306.1,
    y2: 11.1
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 294.2,
    y: 6.2,
    width: 4.9,
    height: 4.9
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86,53V6c0-3.1,2.5-5.6,5.6-5.6h130.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m318.3,20.2V6c0-3.1-2.5-5.6-5.6-5.6h-30.3"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "133.9 11.7 130.9 8.7 133.9 5.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "141.8 5.8 144.8 8.7 141.8 11.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 318.3,
    y1: 16.1,
    x2: 86,
    y2: 16.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m135.3,40.6h-33.7c-3,0-5.4,2.4-5.4,5.4v10.8c0,3,2.4,5.4,5.4,5.4h27.5l6.5,6.5v-6.5c2.9-.1,5.1-2.5,5.1-5.4v-10.8c0-3-2.4-5.4-5.4-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m135.3,97.5h-33.7c-3,0-5.4,2.4-5.4,5.4v23.3c0,3,2.4,5.4,5.4,5.4h28.2l5.8,5.8v-5.8c2.9-.1,5.1-2.5,5.1-5.4v-23.3c0-3-2.4-5.4-5.4-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m135.3,74.4h-33.7c-3,0-5.4,2.4-5.4,5.4h0c0,2.7,2.1,5,4.7,5.4v5.8l5.8-5.8h28.6c3,0,5.4-2.4,5.4-5.4h0c0-3-2.4-5.4-5.4-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m135.3,143.9h-33.7c-3,0-5.4,2.4-5.4,5.4v5.7c0,2.7,2.1,5,4.7,5.4v5.8l5.8-5.8h28.6c3,0,5.4-2.4,5.4-5.4v-5.7c0-3-2.4-5.4-5.4-5.4Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.1,
    y1: 46.8,
    x2: 133.4,
    y2: 46.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.1,
    y1: 79.9,
    x2: 133.4,
    y2: 79.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.1,
    y1: 149.4,
    x2: 133.4,
    y2: 149.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.1,
    y1: 155,
    x2: 128.2,
    y2: 155
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.1,
    y1: 51.4,
    x2: 133.4,
    y2: 51.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.1,
    y1: 56.1,
    x2: 124.6,
    y2: 56.1
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.9,
    y1: 16.1,
    x2: 146.9,
    y2: 169.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m232.1,75.1c2.2,8-.7,16.7-8.3,18.4-5,1.1-10.8-4-13-12-2.2-8,.3-14.9,5-17,7-3,14.1,2.5,16.4,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m306.6,94.4c-19.9-4.7-11.9-19.2-16.2-26-6.8-10.7-13-3.2-18.7-17s-29.8-23.5-46.1-16.1c-17.7,8-15.7,24.1-9.5,35.1,9.9,17.8-8.2,18.7-5.9,32.4,2.3,13.7,7.9,15.7,1.9,26.3,20.6,7.6,89.3-8.6,94.5-34.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m308.6,91.1c-19.6-3.6-12.3-18.2-16.8-24.7-7.1-10.2-12.8-2.5-18.9-15.7-6.1-13.2-25.4-24.6-40.9-16.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m281.7,159.7c0-7.1,0-11.6,0-11.6,0,0-76.6-9.5-76.5-9.3,0,0-1.2,8.8-2.9,20.9h79.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m286,159.7c2.7-19.6,1.1-37.5-11.7-43.5-32.3-15.2-52.5-.2-60.2,12.3-3.1,5.1-6.7,17.1-9.5,31.2h81.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m214.6,133.5c21.3-24,49.2-24.5,51.8-7.7,2.6,16.8,20.3-5.9,14-9.2-6.4-3.2-36-10.1-50.9-4.6-14.8,5.5-14.9,21.4-14.9,21.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m235.6,113.8c5.1-4.2,11.9-6.1,19.3-4.9,15.3,2.5,17.8,15.9,6.3,24.5-14.3,10.6-49.5,0-25.6-19.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m229.4,91.7l8.5,32.9c3,9.9,30.6,1.5,27.7-8.8-2.9-10.3-13.5-48.9-13.5-48.9,0,0-27.8-3.3-22.7,24.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m234.6,43.3c41.3-.5,25.9,60-2.9,64.9-4.5.8-15.1-17.3-15.6-33.1-.5-16.1.3-31.6,18.5-31.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m246.5,100c-4.3,4.3-9.3,7.3-14.9,8.2-4.5.8-15.1-17.3-15.6-33.1-.5-16.1.3-31.6,18.5-31.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m233.4,73.2c2-1.9,3.7,2.3,1.4,3.3-2.4,1-2.2-2.5-1.4-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m218.9,75.2c2-1.9,3.7,2.3,1.4,3.3-2.4,1-2.2-2.5-1.4-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m216.9,69.6c3-2.5,7-1.5,7-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m233.1,67c4-1,7.8,1.9,7.8,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m227.1,71.6c-1.1,8.3-2.3,12.6-2.3,12.6,0,0,.2,1.8,2.8,2.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m216.3,63.1c1.9-13.6,17.3-6.7,21.1-12.9-.3,7.7,9.7,12.4,12,13.7,8.7,5,7.4,19.6,8.6,23.5,5.5-3.9,5.6-14.4,5-27.8-.5-13.4-6.9-22.5-24.3-23.1-17.4-.6-27.9,15.5-22.4,26.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m210.7,159.7c11-30.6,23.7-46.3,23.7-46.3-21.4,0-31.2,22.3-38.3,46.3h14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m230.2,113.4c-11.5,5.5-15.9,14.9-15.9,14.9l3,5.3-6.3,1.7s-2.9,13-4.9,24.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m297.4,159.7c0-17.8-1.6-32.5-7-37.4-7.3-6.6-17.2-10.1-25.7-11,0,0,0,7.4-2.5,11-5.5,7.8-10.6,16.1-12.2,31.8-.2,1.8-.3,3.6-.4,5.6h47.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m273.9,114.9c3.3,9.6-8.2,17-7.9,28-1-.4-9,.7-9,.7l7,8.6s-1.5,3.1-3.4,7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m270.5,159.7c.3-21.6,4.2-37.7,15-38.4,10.3-.6,18.3,15.9,24.4,38.4h-39.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m283.1,121.7c-11.8,4.7-12.8,21.8-11.8,38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.6,113.8c-15.6,15.2-24.9,45.9-24.9,45.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m264.7,111.3c.3,10.8-5,14.7-9,21.6-3.5,6.1-6.3,19.6-6.2,26.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m227.9,94.4c4.7-.1,7.7-3.3,7.7-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m254.4,68.8c4.8,20.3-4.1,52.4-4.1,52.4,0,0,15.1,3.1,32.7-4,17.6-7-28.7-48.5-28.7-48.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m274.6,69.7c2.2,8-.7,16.7-8.3,18.4-5,1.1-10.8-4-13-12-2.2-8,.3-14.9,5-17,7-3,14.1,2.5,16.4,10.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 267.2,
    cy: 72.3,
    rx: 7.8,
    ry: 12.4,
    transform: "translate(-9.6 74.2) rotate(-15.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m270.7,81.3c-3.2.9-6.9-2.5-8.4-7.7-.4-1.5-.6-3-.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m210,49.4c17.3-17.1,34.5-5,39.9,4.9,3.5,6.4,10.2,0,8-4.2-2.2-4.3-15.2-22-35.9-14.1-7.9,3-11.9,13.4-11.9,13.4Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 254.9,
    y1: 56.9,
    x2: 257.7,
    y2: 61.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 257.5,
    y1: 55.1,
    x2: 260.3,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 266.3,
    y1: 70.6,
    x2: 269.4,
    y2: 68.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 267.2,
    y1: 72.9,
    x2: 270.3,
    y2: 71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 268.1,
    y1: 74.9,
    x2: 271.2,
    y2: 73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m257.7,80.2c-5.2,9.5-15.7,11.9-15.7,11.9l1.8,1.2s10.6-2.4,15.8-12c.3-.5,0-1.1-.4-1.4h0c-.5-.3-1.2-.1-1.5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m257.7,80.2c.3-.5,1-.7,1.5-.4h0c.5.3.7.9.4,1.4-.6,1.1-1.4,2.3-2.1,3.2-.8.9-1.7,1.9-1.7,1.9"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 242.9,
    cy: 93,
    r: 3.6
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "163.9 160.1 309.8 160.1 309.8 123.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.3,
    y1: 104.5,
    x2: 133.5,
    y2: 104.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.3,
    y1: 109.9,
    x2: 133.5,
    y2: 109.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.3,
    y1: 115.3,
    x2: 133.5,
    y2: 115.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.3,
    y1: 120.8,
    x2: 133.5,
    y2: 120.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.3,
    y1: 126.2,
    x2: 125.1,
    y2: 126.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 301.1,
    y: 26.8,
    width: 31.3,
    height: 31.1,
    rx: 6.3,
    ry: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 315.4,
    cy: 42.6,
    r: 8.7,
    transform: "translate(214 344.3) rotate(-79.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m315.4,47.4c-.4,0-.8-.1-1-.4l-4.8-4.7c-.6-.6-.6-1.5,0-2.1.6-.6,1.5-.6,2.1,0l3.8,3.6,8.1-8.2c.6-.6,1.5-.6,2.1,0,.6.6.6,1.5,0,2.1l-9.2,9.2c-.3.3-.7.4-1.1.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 11.5,
    y: 222.2,
    width: 223,
    height: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.6,
    y1: 222.2,
    x2: 251.1,
    y2: 222.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    y1: 227.2,
    x2: 228.5,
    y2: 227.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m218.8,220.4h-73c-3.3,0-5.3-2.6-4.5-5.7l13.3-48.3c.5-1.7,2.4-3.2,4.2-3.2h78.4c1.8,0,2.9,1.4,2.5,3.2l-14,50.7c-.9,3.2-3.6,3.3-7,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m154.6,166.4c.5-1.7,2.4-3.2,4.2-3.2h78.4c1.8,0,2.9,1.4,2.5,3.2l-13.3,48.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "222.8 217.4 142.5 217.4 157.2 165.4 237.5 165.4 222.8 217.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "213.5 199 195.1 199 200.1 180.9 218.5 180.9 213.5 199"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m216.2,189.3s-3.2,5.9-8.1,5.2c-4.9-.7-5.6-8.3-9.5-8l-3.4,12.4h18.4l2.7-9.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m206.3,202.7c2.1,0,4.1,0,6.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m200.9,202.7h2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m194.1,202.7c1.4,0,2.6,0,4.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m203.1,205.2c2,0,4,0,6,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m198.2,205.2h2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m193.4,205.2h2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m200.1,207.8c3.5,0,7,0,10.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m196,207.8h1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m192.7,207.8h1.1"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "219.5 177.3 201.1 177.3 202.1 173.7 220.5 173.7 219.5 177.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "193.4 180.4 165.3 180.4 167.2 173.7 195.3 173.7 193.4 180.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "187.2 203.1 159.1 203.1 164.2 184.6 192.3 184.6 187.2 203.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 157.8,
    y1: 207.7,
    x2: 185.9,
    y2: 207.7
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m225.2,217.4c-.7,2.3-1.8,4-4.6,4h-84.2c-2.8,0-4.1-1.7-4.8-4h93.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m193.3,217.4c-.7,2.3-1.8,4-4.6,4h-84.2c-2.8,0-4.1-1.7-4.8-4h93.6Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.7,
    y1: 217.4,
    x2: 193.3,
    y2: 217.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m114.8,301.1c-11.1-18.9-20.3-34.6-20.3-34.6,2.6-1.9,33.8-12.6,34.9-12.5.5,0,11.2,22.7,22.6,47.1h-37.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m152.3,301.1c5.2-11.2,9.2-19.6,9.2-19.6,0,0-46.6,2.5-74.2,2.5s-35.5-43.9-35.5-43.9l33.6-5.3,100.2,17c12.7,2.4,14.6,18.2,8.5,29.6,0,0-3.4,8.2-8.2,19.6h-33.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m131.3,282.6l30.1-1.2s-4.3,9.2-9.2,19.6"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 98.9,
    cy: 118.6,
    rx: 4.9,
    ry: 2.4,
    transform: "translate(-39.8 186.4) rotate(-76.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m63.8,125.6c-11.7-10.2-7.5-30.9,9.6-32.6,17.2-1.6,19.1,2.7,21.1,8.3s3.5,8.3,4.2,11.6c.6,3.2-1.5,3.9-1.4,7,0,1.3,2.6,5.6,3,7.8.2,1.1-3.3,1.9-3.3,1.9,0,0-.4,13.1-5.2,15.9-4.8,2.8-22.2-9.1-27.9-19.8Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "76.2 121.8 67.6 119 54.8 154.2 75.8 158.6 80 123.1 76.2 121.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "69.8 116.5 54.9 153.9 79.2 158.5 82 137.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m202.4,212.5l-9.7-6.9c-.6-.4-1.4-.5-2-.2l-.4.2c-.4.1-.9.3-1.5.6h-.2c-.6-.5-1.3-.7-2-.3-.6.2-1.2.7-1.9,1.3-.6-.4-1.3-.5-2-.2-1.4.6-3.2,2.5-4.4,3.9-1,.4-1.9.8-2.7,1.1-1.1.4-2,1-2.7,1.7l-37.4-10.8-33.6-39.5-11.7,24.1,32.9,30.3c3.1,2.8,7.1,4.4,11.2,4.4h44c3.7,0,6.4-1.7,9.4-6.1.3-.4.6-.9.8-1.3l3.6,2.6c.5.3,1,.4,1.5.4.5,0,1.1-.4,1.4-.9.2-.3.3-.7.4-1l.6.4c.5.3,1,.4,1.5.4.5,0,1.1-.4,1.4-.9.1-.2.2-.3.3-.5l.9.6c.5.3,1,.4,1.5.4.5,0,1.1-.4,1.4-.9.7-.9.4-2.2-.5-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m74.5,283.7h-30.2c-5.3,0-9.7-4-10.2-9.2l-2.3-22.6c-.5-4.9,2.5-9.4,7.1-10.9,10.7-3.4,30.1-8.6,45.6-7,6.2.6,10.4,6.6,9,12.7l-6.4,27.1c-1.4,5.9-6.6,10-12.6,10Zm4.7-10l6.4-27.1c1.4-6.1-2.8-12.1-9.1-12.7-15.5-1.6-34.8,3.6-45.5,7-4.7,1.5-7.6,6-7.2,10.9l1.9,18.4c.8,7.6,7.2,13.5,14.9,13.5h25.9c6,0,11.3-4.1,12.6-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m30,165.7s18.1-20.3,32.8-20.3,35.4,9.5,41.3,16.9,21.5,25.1,21.5,25.1l-19.5,16.9-8-6.7s5.7,38.2,21,44.1l-31.4,39.1s-28.4,4.8-42.2-12.2c-13.8-17-21.5-87-15.6-103.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m62.8,134c-4.6-18.2-13.8-26.2-6.8-35,7-8.9,17.8-6.1,18.1-6.8s11-5.9,17.1-2.8c11.6,6,3.3,16.5,3.3,16.5,0,0-3.3,9.8-3.8,15-.5,5.1,1.7,9.9,5.7,10.7,3.9.8,1.3,16.5-1.3,17-3,.6-6,.8-11.3-4.4,6.1-2.6,3.7-16,4.2-25.8s-12.5-7.4-8.4,3.6c2.7,7.1-10.5,11.6-16.8,12.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.5,93.4c10.7-3.4,14.6-1.2,14.6-1.2,0,0,0-1.3,2.2-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m98.9,98.8c-.8,2.9-2.5,5.4-4.9,7.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m87.7,115.2c-1.3-3-4.4-5.2-6.4-3-2.5,2.8-1.1,8.6,1.6,10.2.8-2.9,2.4-5.6,4.9-7.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 85.4,
    y1: 119.2,
    x2: 83.3,
    y2: 114.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m87.8,115.6c-1.2-3.2-4.5-5.7-6.6-3.3-3,3.3-.5,10.9,3.3,10.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86.9,113.8c1.2.3,15.9,4.1,15.9,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.4,283.7c-8,0-14.1-6.5-13.6-14.5l1.9-31.6c.1-1.7-.1-3.5-.6-5.1l-13.6-42.5c-1.8-5.7,2.4-11.4,8.3-11.4h29.7c6.9,0,13.1,4.3,15.4,10.8l15.5,43.1c.6,1.6.9,3.4.8,5.1l-.7,31.6c-.2,8,6.2,14.5,14.2,14.5h-57.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m25.7,178.5h29.7c6.9,0,13.1,4.3,15.4,10.8l15.5,43.1c.6,1.6.9,3.4.8,5.1l-.7,31.6c-.2,8,6.2,14.5,14.2,14.5h-57.3c-8,0-14.1-6.5-13.6-14.5l1.9-31.6c.1-1.7-.1-3.5-.6-5.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.7 187.5 106.2 204.4 116.8 190.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.7,154c-18.9-2.4-14.9,20.1-14.9,20.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.2,
    y1: 189.9,
    x2: 98.2,
    y2: 197.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 119.3,
    y1: 241.9,
    x2: 90.2,
    y2: 277.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 92.7,
    y1: 201.1,
    x2: 102.1,
    y2: 246.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 51.2,
    y1: 231.1,
    x2: 82,
    y2: 231.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37,
    y1: 235.4,
    x2: 62.1,
    y2: 235.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m132.9,283.7h-30.2c-5.3,0-9.7-4-10.2-9.2l-2.3-22.6c-.5-4.9,2.5-9.4,7.1-10.9,10.7-3.4,30.1-8.6,45.6-7,6.2.6,10.4,6.6,9,12.7l-6.4,27.1c-1.4,5.9-6.6,10-12.6,10Zm4.7-10l6.4-27.1c1.4-6.1-2.8-12-9-12.7-15.5-1.6-34.9,3.6-45.6,7-4.7,1.5-7.6,6-7.1,10.9l2.3,22.6c.5,5.2,4.9,9.2,10.2,9.2h30.2c6,0,11.3-4.1,12.6-10Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m137.7,273.7l6.4-27.1c1.4-6.1-2.8-12-9-12.7-.7,0-1.5-.1-2.2-.2-13.1.7-27,4.5-35.4,7.2-4.7,1.5-7.6,6-7.1,10.9l2.3,22.6c.5,5.2,4.9,9.2,10.2,9.2h22.3c6,0,11.3-4.2,12.6-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m83.5,263.7l1.1,10.8c.5,5.2,4.9,9.2,10.2,9.2h7.9c-5.3,0-9.7-4-10.2-9.2l-2.3-22.6c-.5-4.9,2.5-9.4,7.1-10.9,8.4-2.7,22.3-6.5,35.4-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m102.7,283.7h30.2c6,0,11.3-4.2,12.6-10l6.4-27.1c1.4-6.1-2.8-12-9-12.7-3.3-.3-6.7-.4-10.2-.2.8,0,1.5.1,2.2.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m84.3,244.7c1.7-2.6,4.9-3.7,5.9-4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m72.4,292.2v8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m94.1,283.7c-1.6,4.9-6.2,8.5-11.6,8.5h-20.1c-5.4,0-10-3.6-11.6-8.5"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 199.1,
    y1: 215.3,
    x2: 192.8,
    y2: 210.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 195.4,
    y1: 215.9,
    x2: 192,
    y2: 213.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m190.2,211.3c-.5,1.9-1.7,3.6-1.7,3.6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNano4);
export default __webpack_public_path__ + "static/media/nano4.238d90e617eb83f0bb333f6576e561b2.svg";
export { ForwardRef as ReactComponent };